import { useState } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

export interface ISidebarProps {
  title: string;
  icon: React.ReactNode;
  isHidden?: boolean;
  children: React.ReactNode;
}

export const SidebarItem = (props: ISidebarProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (props.isHidden) return null;
  return (
    <div
      className={cn(
        'border-b-gray-200 mb-2 cursor-pointer border-b last:mb-0 last:border-b-0',
        PaletteUtils.isVcfcPalette && 'border-b-gray-black/40',
      )}
    >
      <div
        className={cn('mb-2 flex min-h-11 py-4 transition-colors duration-200', 'hover:bg-smoky-white dark:hover:bg-transport-black')}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div
          className={cn(
            'mr-3 flex h-5 w-5 flex-none items-center justify-center text-center text-xl text-slate transition duration-200 dark:text-white',
            PaletteUtils.isInsigniaPalette && [isOpen && 'text-primary dark:text-primary'],
          )}
        >
          {props.icon}
        </div>
        <Text className='flex-auto'>{props.title}</Text>
        <div
          className={cn(
            'mr-3 flex h-5 w-5 flex-none items-center justify-center text-center text-xl transition-transform duration-200',
            isOpen ? 'rotate-90' : '-rotate-90',
          )}
        >
          <Icon icon={<ChevronIcon />} />
        </div>
      </div>
      <div className={cn(!isOpen ? 'hidden' : 'block pt-3')}>{props.children}</div>
    </div>
  );
};
